import React, { Component } from 'react';
import ExecuteSider from '../ExecuteSider';
import Detail from './Detail';
import Summary from './Summary';

class Manhour extends Component {
    state = {
        cur: 'detail',
        relateId: '',
    }

    componentDidMount() {
        if (this.props.match && this.props.match.params.relateId) {
            this.setState({ relateId: this.props.match.params.relateId });
            this.handleBtnClick('summary');
        }
    }

    handleBtnClick = (cur) => {
        this.setState({ cur });
    }

    render() {
        const { cur, relateId } = this.state;
        return (
            <div className="content">
                <ExecuteSider selectKey="manHour" />
                <div className="main">
                    <div className="main-content">
                        <div className="tab_flex">
                            <a onClick={() => this.handleBtnClick('detail')} className={cur == 'detail' ? 'curr' : ''} >
                                明细记录
                            </a>
                            <a onClick={() => this.handleBtnClick('summary')} className={cur == 'summary' ? 'curr' : ''} >
                                汇总记录
                            </a>
                        </div>
                        { cur === 'detail' && <Detail /> }
                        { cur === 'summary' && <Summary userFteSummaryId={relateId} /> }
                    </div>
                </div>
            </div>
        );
    }
}

export default Manhour;


// WEBPACK FOOTER //
// ./src/components/execute/manHour/index.js